import React, { useState } from "react";
import logo from "../assets/logo.png";
import { CiUser } from "react-icons/ci";
import { HiMenu, HiX } from "react-icons/hi";
import product from "../assets/product1.png";
import product1 from "../assets/product2.png";
import product2 from "../assets/product3.png";
import product3 from "../assets/product4.png";
import product4 from "../assets/product5.png";
import product5 from "../assets/product6.png";
import product6 from "../assets/product7.png";
import product7 from "../assets/product8.png";
import sanitory from "../assets/sanitory.png";
import icon11 from "../assets/icon11.png";
import icon12 from "../assets/icon12.png";
import icon13 from "../assets/icon13.png";
import icon14 from "../assets/icon14.png";
import face from "../assets/face.png";
import twit from "../assets/video.png";
import insta from "../assets/insta.png";
import icon from "../assets/icon.png";
import icon1 from "../assets/icon1.png";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import { Link } from "react-router-dom";
import ProductInfo from "./ProductInfo";
import ProductImageGallery from "./ProductImageGallery";
import adb from "../assets/adb.png";
import adultdiaper from "../assets/adultdiaper.png";
import pbwm from "../assets/pbwm.png";
import ad1 from "../assets/ad1.png";
import ad2 from "../assets/ad2.png";
import ad11 from "../assets/icons/Breathable.png";
import adt2 from "../assets/icons/soft.png";
import adt3 from "../assets/icons/water_proof.png";
import adt4 from "../assets/icons/bacteria.1.png";
import returnIcon from "../assets/icons/arrow-right-left.svg";
import shippingIcon from "../assets/icons/la--shipping-fast.svg";
import adultDiaperFooterBanner from "../assets/adultDiaperFooterBanner.jpg";

function Product1() {
    return (
        <>
            <Header />
            <Banner />
            <ProductDetail />
            <Siteicons />
            {/* <Imageround /> */}
            <ExtraSection />
            <ExtraSection1 />
            <ExtraSection2 />
            {/* <ProductDetail1 />
      <ProductDetail2 />
      <ProductDetail3 /> */}
            <FAQSection />
            <FooterBanner />
            <Footer />
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative hidden">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser className="hidden" />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function Banner() {
    return (
        <div
            className=" lg:w-full  max-md:w-full md:w-full lg:h-screen max-md:h-screen md:h-[60vh] lg:bg-center lg:bg-no-repeat lg:bg-cover lg:object-fit-cover max-sm:w-full max-sm:h-[25vh]"
            style={{
                backgroundImage: `url(${adb})`,
                backgroundSize: "cover", // Ensures the image covers the entire area
                backgroundPosition: "fit",
            }}
        >
            {/* Top Offer Bar */}
        </div>
    );
}

function ProductDetail() {
    return (
        <div className="mt-20 bg-white space-y-10 mx-auto  px-4 md:px-0">
            <h2 className="text-4xl text-center font-bold">Product Features</h2>
            <h3 className="text-center text-xl font-[500] py-4">
                Bestie Adult Diapers: Comfort And Confidence For Every Moment
            </h3>
            <p className="font-regular text-lg">
                Embrace comfort and confidence with Bestie Adult Diapers, the{" "}
                perfect choice for all-day wear. Engineered with your comfort in{" "}
                <br />
                mind, our diapers provide unparalleled softness and a snug fit,
                ensuring you stay comfortable and confident throughout your day.
            </p>
            <p className=" font-regular mt-5 text-lg">
                With advanced absorbent technology, Bestie Adult Diapers offer
                superior leakage protection, allowing you to move freely without{" "}
                <br />
                worry. Whether you're at work, traveling, or simply enjoying
                life's moments, our diapers provide reliable protection, giving
                you the <br /> confidence to live life on your terms.
            </p>
            <p className=" font-regular mt-5 text-lg">
                Designed for extended wear, Bestie Adult Diapers are gentle on
                the skin, preventing chafing and discomfort. Say goodbye to{" "}
                <br />
                irritation and hello to a new level of comfort with our premium
                diapers.
            </p>
            <p className=" font-regular mt-5 text-lg">
                With Bestie Adult Diapers, you can embrace each moment with
                confidence and dignity. Don't let bladder leakage hold you back{" "}
                <br />– experience the comfort and reliability of Bestie today!
            </p>
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                {/* <div className="flex items-center space-x-2 text-sm text-gray-500">
          <a href="/" className="font-sans text-lg font-medium hover:text-gray-700">Home</a>
          <span className="text-gray-400">›</span>
          <a href="/products" className="font-sans text-lg font-medium hover:text-black">Products</a>
          <span className="text-gray-400">›</span>
          <span className="font-sans text-lg font-medium hover:text-black">Bestie - Adult Diapers</span>
        </div> */}
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="w-full lg:w-1/2">
                        {/* <img
              src={product1}
              alt="Product Image"
               className="relative z-0 pl-10 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110"
            /> */}
                    </div>
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        {/* <h2 className="text-3xl font-bold">Bestie - Sanitory Pads</h2> */}
                        {/* <p className="mt-4 text-left text-gray-600">Welcome to a new era of personal hygiene with Bestie Sanitary Pads! 
Designed to offer unmatched comfort and protection, these pads are the ultimate choice for women who demand the best. Discover a world where your comfort and well-being are our top priorities.<br></br><br></br>
Indulge in the softness of our sanitary pads, featuring a super soft compressed random fibers surface that feels like a gentle caress against your skin. Beneath this luxurious surface lies advanced technology that ensures rapid absorption and superior leak protection, keeping you dry and comfortable all day long.<br></br><br></br>
Say goodbye to worries about leaks and discomfort. Our pads are equipped with a 3D leak guard that prevents side leakage, providing extra confidence and peace of mind. Plus, the anion strip with graphene neutralizes odors and offers antibacterial benefits, ensuring you feel fresh and clean.<br></br><br></br>
Experience enhanced hygiene with our air-laid sterilized paper, which creates a 360-degree sterile environment. Super absorbent polymers handle heavy flows with ease, reducing the need for frequent changes. The breathable, water-resistant bottom layer allows efficient air circulation, eliminating heat and moisture.<br></br><br></br>
Bestie sanitary pads also feature a high-level release mechanism for easy peel-and-stick convenience and are individually packed to ensure locked hygiene and cleanliness. Carry them in your bag or purse without worrying about contamination.<br></br><br></br>
Experience the perfect blend of comfort, protection, and hygiene with Bestie Sanitary Pads. Because when it comes to your health, only the best will do. Treat yourself to the care you deserve – shop Bestie Sanitary Pads today and feel the difference!<br></br><br></br>

</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
function Siteicons() {
    const fabiconsarray = [
        {
            id: 1,
            className: "w-20 h-10",
            imageSrc: ad11,
            imageAlt: "rashes icon",
            name: "Adult diapers with breathable materials and moisture-wicking layers protect the skin from irritation.",
            href: "/adt1",
        },
        {
            id: 2,
            imageSrc: adt2,
            imageAlt: "feature soft",
            name: "It prevents irritation and rashes, keeping the skin dry and comfortable while offering reliable absorbency.",
            href: "/adt2",
        },
        {
            id: 3,
            imageSrc: adt3,
            imageAlt: "lock",
            name: "Quickly absorbs and locks in moisture, keeping the skin dry and preventing leaks for extended comfort.",
            href: "/adt3",
        },
        {
            id: 4,
            imageSrc: adt4,
            imageAlt: "chemical free",
            name: "Helps control and neutralize unpleasant smells, keeping the wearer feeling fresh and confident throughout the day.",
            href: "/adt4",
        },
    ];
    return (
        <div className="mt-3 bg-white">
            <div className="px-4 py-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
                {/* <div className="flex items-center space-x-2 text-sm text-gray-500">
          <Link to="/" className="font-sans text-lg font-medium hover:text-gray-700">Home</Link>
          <span className="text-gray-400">›</span>
          <Link to="/products" className="font-sans text-lg font-medium hover:text-black">Products</Link>
        </div> */}

                <div className="px-10 py-10 mx-auto max-w-9xl sm:px-8 lg:px-8">
                    <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-4 lg:grid-cols-4 lg:gap-x-8 xl:gap-x-8">
                        {fabiconsarray.map((product) => (
                            <div
                                key={product.id}
                                className="relative overflow-hidden bg-white border border-grey-200 shadow-lg group rounded-xl"
                            >
                                <div className=" w-100 h-[60%] flex items-center justify-center  px-2 py-2 bg-[#F2AEB3] aspect-w-1 aspect-h-1 rounded-t-xl lg:aspect-h-1">
                                    <img
                                        src={product.imageSrc}
                                        alt={product.name}
                                        className="w-[90%] h-[90%]  relative z-0 pt-0 pb-0 pl-0 pr-0 transition-all duration-300 rounded-lg lg:w-5/5 hover:scale-110 text-center"
                                    />
                                </div>
                                <div className="text-bold p-10 space-y-5  text-center text-black-500">
                                    <h3 className="text-bold text-lg     text-black">
                                        {product.name}
                                    </h3>
                                    {/* <div className="flex items-center justify-between"> */}
                                    {/* <p className="text-lg font-bold text-black-900">{product.price}</p> */}
                                    {/* <Link to={product.href}>
                      <button className="py-1 px-4 bg-[#52B3A4] text-white text-sm rounded-md hover:bg-[#52B3A4]">
                        Shop Now
                      </button>
                    </Link> */}
                                    {/* </div> */}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

function ExtraSection() {
    return (
        <div className="mt-1 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-6">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        <h2 className="text-3xl font-bold">
                            Bestie Adult Diapers: Comfort And Confidence For
                            Every Moment
                        </h2>
                        <p className="mt-4 text-left text-gray-600 text-lg">
                            •
                            <span className="font-semibold">
                                Advanced Absorbent Technology:
                            </span>{" "}
                            Dual core padding in the target zone ensures optimal
                            absorption, providing unparalleled leakage
                            protection. <br />
                            <br /> •{" "}
                            <span className="font-semibold">
                                Snug Yet Gentle Fit:
                            </span>{" "}
                            Designed for comfort and discretion, our diapers
                            offer a snug fit that allows you to move with
                            freedom and confidence <br />
                            <br /> •{" "}
                            <span className="font-semibold">
                                All-Day Wear:
                            </span>{" "}
                            Suitable for extended wear, Bestie Adult Diapers
                            guarantee comfort and reliability in any situation,
                            empowering you to seize the day without worries.
                        </p>
                        {/* <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p> */}

                        {/* <a href="https://wa.me/message/WYDNZKOCNVM5A1">

            <button className="mt- px-10 py-4 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

          </a> */}
                    </div>
                    <div
                        className="md:w-full md:lg:w-1/3 md:ml-20"
                        style={{
                            backgroundImage: `url(${pbwm})`,
                            backgroundSize: "cover", // Ensures the image covers the entire area
                            backgroundPosition: "fit",
                        }}
                    >
                        <img
                            src={ad1}
                            alt="Product Image"
                            className="relative z-0 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110 pl-30"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function ExtraSection1() {
    return (
        <div className="mt-1 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col-reverse mt-6 lg:flex-row">
                    <div
                        className="w-full lg:w-1/3 mr-20"
                        style={{
                            backgroundImage: `url(${pbwm})`,
                            backgroundSize: "cover", // Ensures the image covers the entire area
                            backgroundPosition: "fit",
                        }}
                    >
                        <img
                            src={adultdiaper}
                            alt="Product Image"
                            className="relative z-0 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110 pl-30"
                        />
                    </div>

                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-30">
                        {/* <h2 className="text-3xl font-bold">About the Product - features</h2> */}

                        <p className="mt-4 text-left text-gray-600 text-lg">
                            •
                            <span className="font-semibold">
                                Odor Control Technology:
                            </span>{" "}
                            Bestie Adult Diapers feature advanced odor control
                            technology, keeping you feeling fresh and confident
                            throughout the day. <br />
                            <br /> •{" "}
                            <span className="font-semibold">
                                Soft, Breathable Materials:
                            </span>{" "}
                            Crafted with soft, breathable materials, our diapers
                            ensure skin comfort and prevent irritation, even
                            during extended wear. <br />
                            <br />
                        </p>

                        {/* <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p> */}

                        {/* <a href="https://wa.me/message/WYDNZKOCNVM5A1">

            <button className="mt- px-10 py-4 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

          </a> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

function ExtraSection2() {
    return (
        <div className="mt-1 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        {/* <h2 className="text-3xl font-bold">About the Product - features</h2> */}
                        <p className="mt-4 text-left text-gray-600 text-lg">
                            •
                            <span className="font-semibold">
                                Universal Design:
                            </span>{" "}
                            Tailored for both men and women, our diapers offer
                            universal comfort and reliability, catering to
                            diverse needs and preferences. <br />
                            <br /> •{" "}
                            <span className="font-semibold">
                                Variety Of Sizes:
                            </span>{" "}
                            Available in a range of sizes, Bestie Adult Diapers
                            are designed to suit individual needs, ensuring a
                            perfect fit for everyone. <br />
                            <br />
                        </p>
                        {/* <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p> */}
                    </div>
                    <div
                        className="md:w-full md:lg:w-1/3 md:ml-20"
                        style={{
                            backgroundImage: `url(${pbwm})`,
                            backgroundSize: "cover", // Ensures the image covers the entire area
                            backgroundPosition: "fit",
                        }}
                    >
                        <img
                            src={ad2}
                            alt="Product Image"
                            className="relative z-0 transition-all duration-300 rounded-lg  lg:w-13/12 hover:scale-110 pl-30"
                        />
                    </div>
                </div>
                <a
                    href="https://wa.me/message/WYDNZKOCNVM5A1"
                    className="ml-10 "
                >
                    <button className="mt-10 px-5 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">
                        {" "}
                        Shop Now
                    </button>
                </a>
            </div>
        </div>
    );
}

// function ProductDetail1() {
//   return (
//     <div className="mt-10 bg-white">
//       <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
//         <div className="flex items-center space-x-2 text-sm text-gray-500">
//               </div>
//         <div className="flex flex-col mt-6 lg:flex-row">
//           <div className="w-full lg:w-1/2">

//             {/* <img
//               src={product2}
//               alt="Product Image"
//               className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
//             /> */}
//           </div>
//           <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
//             {/* <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
//             <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
//             <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>

//           <a href="https://wa.me/message/WYDNZKOCNVM5A1">

//             <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

//           </a> */}
//         </div>
//       </div>
//     </div>
//     </div >
//   );
// }

// function ProductDetail2() {
//   return (
//     <div className="mt-10 bg-white">
//       <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
//         <div className="flex items-center space-x-2 text-sm text-gray-500">

//         </div>
//         <div className="flex flex-col mt-6 lg:flex-row">

//           {/* <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
//             <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
//             <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
//             <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>

//           <a href="https://wa.me/message/WYDNZKOCNVM5A1">

//             <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

//           </a> */}
//         {/* </div> */}
//         <div className="w-full lg:w-1/2">

//         {/* <img
//               src={product2}
//               alt="Product Image"
//               className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
//             />      */}
//             </div>
//       </div>
//     </div>
//     </div >
//   );
// }

// function ProductDetail3() {
//   return (
//     <div className="mt-10 mb-10 bg-white">
//       <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
//         <div className="flex items-center space-x-2 text-sm text-gray-500">
//               </div>
//         <div className="flex flex-col mt-6 lg:flex-row">
//           <div className="w-full lg:w-1/2">

//           {/* <img
//               src={product4}
//               alt="Product Image"
//               className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
//             />  */}
//              </div>
//           <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
//             {/* <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
//             <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
//             <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>
//            */}

//           {/* <a href="https://wa.me/message/WYDNZKOCNVM5A1">

//             <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

//           </a> */}
//         </div>
//       </div>
//     </div>
//     </div >
//   );
// }

// // function RecommendedProducts() {
// //   const recommendedProducts = [
// //     {
// //       id: 1,
// //       name: "Bestie - Product 1",
// //       price: "₹550.00",
// //       imageSrc: product,
// //       href: "/product1",
// //     },
// //     {
// //       id: 2,
// //       name: "Product 2 Microfabric Fabric",
// //       price: "₹799.00",
// //       imageSrc: product1,
// //       href: "/product2",
// //     },
// //     {
// //       id: 3,
// //       name: "Microfabric Fabric T-Shirt",
// //       price: "₹799.00",
// //       imageSrc: product2,
// //       href: "/product3",
// //     },
// //     {
// //       id: 4,
// //       name: "Round Neck Full Sleeve T-Shirt",
// //       price: "₹599.00",
// //       imageSrc: product3,
// //       href: "/product4",
// //     },
// //   ];

// //   return (
// //     <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
// //       <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-6 xl:gap-x-8"></div>
// //       <h2 className="mb-10 font-sans text-2xl font-medium hover:text-black">Recommended Products</h2>

// //       <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
// //         {recommendedProducts.map((product) => (
// //           <div key={product.id} className="relative overflow-hidden bg-white border border-gray-200 shadow-lg group rounded-xl">
// //           <div className="w-full px-2 py-2 bg-white aspect-w-1 aspect-h-1 rounded-t-xl lg:aspect-none">
// //             <img
// //               src={product.imageSrc}
// //               alt={product.name}
// //               className="object-cover object-center w-full h-full lg:w-full lg:h-full"
// //             />
// //           </div>
// //           <div className="p-4 space-y-2">
// //             <h3 className="text-sm text-gray-700">
// //               {product.name}
// //             </h3>
// //             <div className="flex items-center justify-between">
// //               <p className="text-lg font-medium text-gray-900">{product.price}</p>
// //               <Link to={product.href}>
// //                 <button className="py-1 px-4 bg-[#52B3A4] text-white text-sm rounded-md hover:bg-[#52B3A4]">
// //                   Shop Now
// //                 </button>
// //               </Link>
// //             </div>
// //           </div>
// //         </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "How do I choose the right size for Bestie Adult Diapers? ",
            answer: "To ensure the best fit, refer to our size chart and measure your waist or hip circumference. A proper fit is essential for comfort and leak protection. If you are between sizes, consider your comfort preference—snug for security or slightly looser for more breathability. ",
        },
        {
            question: "Can Bestie Adult Diapers be used for overnight protection? ",
            answer: "Yes, Bestie Adult Diapers are designed for extended wear and feature advanced absorbent technology, making them suitable for overnight use. However, if you require extra protection for heavy incontinence, you may need to consider additional absorbent pads. ",
        },
        {
            question: " Are Bestie Adult Diapers discreet under clothing?",
            answer: "Absolutely! Our diapers are designed to be slim yet highly absorbent, ensuring a discreet fit under clothing. The snug yet gentle fit allows for easy movement without bulkiness or noise.",
        },
        {
            question: " How often should I change my adult diaper? ",
            answer: "For maximum comfort and hygiene, we recommend checking every 4–6 hours during the day and changing immediately if the diaper feels full or wet. Overnight use may vary based on absorbency levels.",
        },
        {
            question: "  Do Bestie Adult Diapers cause skin irritation? ",
            answer: "No, our diapers are made from soft, breathable materials designed to prevent irritation and chafing.They also include odor control and moisture-wicking features to keep your skin dry and healthy. If you have sensitive skin, ensure you change the diaper regularly and use a barrier cream if needed.",
        },
        {
            question: "Can I wear Bestie Adult Diapers while being active or traveling? ",
            answer: "Yes! Bestie Adult Diapers are made for active lifestyles and extended wear, providing a snug, comfortable fit that allows free movement. Whether you're working, traveling, or exercising, they offer reliable protection without compromising comfort.",
        },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="w-full py-16 bg-gray-50">
            {" "}
            {/* Full section wrapper with padding */}
            <div
                className="max-w-4xl 
      px-4 mx-auto sm:px-6 lg:px-8"
            >
                {" "}
                {/* Container for equal left-right space */}
                <h2 className="font-sans text-3xl font-semibold tracking-tight text-center text-gray-900">
                    Frequently Asked Questions
                </h2>
                <br></br>
                {/* FAQ List */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="pb-4 border-b-2 border-gray-200 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="font-sans text-lg font-semibold text-gray-700">
                                    {faq.question}
                                </h3>
                                <svg
                                    className={`w-6 h-6 transition-transform transform ${
                                        activeIndex === index
                                            ? "rotate-180"
                                            : ""
                                    }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                            {activeIndex === index && (
                                <p className="mt-2 text-gray-600">
                                    {faq.answer}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function FooterBanner() {
    return (
        <img
            src={adultDiaperFooterBanner}
            alt="Banner"
            className="max-sm:object-contain max-sm:mx-0 max-sm:mb-0 object-fit lg:w-full lg:h-[90vh]"
        />
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-3">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={shippingIcon}
                        alt="Safe Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Shipping All Over India
                    </h3>
                </div>

                {/* Column 2 */}
                {/* <div className="flex flex-col items-center">
          <img src={icon1} alt="Secure Payment" className="w-12 h-12" />
          <br></br>
          <h3 className="font-sans font-bold">Secure Payment</h3>
          <p className="font-sans font-normal ">Guaranteed safe checkout</p>
        </div> */}

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Dedicated Customer Support
                    </h3>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={returnIcon}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Safe and quick delivery
                    </h3>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://www.facebook.com/bestie.care.hygiene/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.youtube.com/@BestieHygiene"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="youtube" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.instagram.com/bestie.hygienecare/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D# "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Bestie care. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default Product1;
